// Tiny self-contained confetti burst. Spawns a handful of emoji particles that
// fly out from an anchor element and clean themselves up. Styling + keyframes
// live in app.css (.confetti-layer / .confetti-piece).

const EMOJIS = ['⭐', '🎉', '✨', '🌟', '🎈', '🍭']

export function celebrate(anchorEl, { count = 18, duration = 1600 } = {}) {
  // Use the anchor only if it's still on-screen with a real size; otherwise burst
  // from the screen centre (avoids a top-left corner burst on a detached node).
  const r = anchorEl && anchorEl.isConnected ? anchorEl.getBoundingClientRect() : null
  const usable = r && (r.width > 0 || r.height > 0)
  const cx = usable ? r.left + r.width / 2 : innerWidth / 2
  const cy = usable ? r.top + r.height / 2 : innerHeight / 2

  const layer = document.createElement('div')
  layer.className = 'confetti-layer'

  for (let i = 0; i < count; i++) {
    const piece = document.createElement('div')
    piece.className = 'confetti-piece'
    piece.textContent = EMOJIS[i % EMOJIS.length]
    // spread pieces in all directions with a slight upward bias
    const angle = (Math.PI * 2 * i) / count + (i % 2 ? 0.3 : 0)
    const dist = 120 + (i % 5) * 40
    piece.style.left = cx + 'px'
    piece.style.top = cy + 'px'
    piece.style.setProperty('--dx', Math.cos(angle) * dist + 'px')
    piece.style.setProperty('--dy', (Math.sin(angle) * dist - 60) + 'px')
    piece.style.setProperty('--rot', (i % 2 ? 1 : -1) * (180 + i * 25) + 'deg')
    piece.style.animationDuration = duration + 'ms'
    layer.appendChild(piece)
  }

  document.body.appendChild(layer)
  setTimeout(() => layer.remove(), duration + 100)
}
